import Components from "slotworks/components/components";
import FlexiButton from "slotworks/graphics/elements/flexi-button";
import Layers from "slotworks/graphics/layers/layers";
import RevolverInit from "slotworks/integration/revolver/states/revolver-init";
import SettingsModel, { Jurisdiction } from "slotworks/model/settings/settings-model";
import Contract from "slotworks/utils/contract";
import { sequence } from "slotworks/utils/race-utils";
import Translations from "slotworks/i18n/translations";
import LinesComponent from "components/lines/lines-component";
import SlotDefinition from "slotworks/model/slot-definition";
import betModel from "slotworks/model/bets/bet-model";
import DSComponents from "components/components";
import { CANVAS_SIZES } from "names/parrot-names"
import DSPromptComponent from "components/prompt/prompt-component";
import deviceInfo from "slotworks/utils/device-info";
import DSSpinReelTransition from "components/matrix/transition/spin-reel-transition";
import DSReelSpinner from "components/matrix/transition/reel-spinner";
import soundManager from "slotworks/sound/sound-manager";
import smartButton, { SmartButtonFlag } from "slotworks/smart-button/smart-button";
import DisabledSkipButtonBehaviour from "smart-button/skip-disabled-button-behaviour";
import gameState from "slotworks/model/game-state";
import ICSpinRecord from "integration/revolver/schema/spin-record";
import ICFreespinRecord from "integration/revolver/schema/freespin-record";
import CelebrateWinComponent from "components/celebrate-win/celebrate-win-component";
import NotificationPopup from "components/promo-popups/notification-popup";
import currency from "slotworks/i18n/currency";
import Logger = require("js-logger");
import settingsModel from "slotworks/model/settings/settings-model";
import canvasManager, { Orientation } from "slotworks/graphics/canvas/canvas-manager";
import autoplayModel from "slotworks/model/autoplay-model";
import { GlowFilter } from "pixi-filters";
import RevolverSettings from "model/revolver-settings";

declare const __VERSION__: string;
export default class ICInit extends RevolverInit {

    //    protected portraitScale: number =  CANVAS_SIZES.DEFAULT_PORTRAIT_SCALE;
    private homeButton: FlexiButton;
    private homeURL: string;

    public complete() {
        this.setupHideBetbarDuringPrompts();
        this.showIntroTexts();

        Layers.Custom.get("CoinCollectPots").moveBehind(Layers.SymbolAnimations);

        Components.matrix.stickyLayer = Layers.MatrixForeground;

        Components.lines = new LinesComponent(SlotDefinition.lineDefinitions);

        // Components.prompt = new DSPromptComponent();
        Components.celebrateWin = new CelebrateWinComponent();

        Components.betBar.onBetUpdated.addOnce(() => {
            const notification = new NotificationPopup();
            notification.show();
        });

        const config = Components.config.matrix;
        let tconfig = config.transition.options;
        let transition = new DSSpinReelTransition(tconfig.startGap, tconfig.stopGap, tconfig.quickStopGap, tconfig.allowPartialSkips)
        Components.matrix.setTransition(transition);
        DSReelSpinner.spinStages = config.transition.options.spinStages;
        DSReelSpinner.skipStages = config.transition.options.skipStages;
        DSReelSpinner.anticipationStages = config.transition.options.anticipationStages;

        Layers.PaytableContent.onSceneEnter.add((scene: string) => {
            let betText = Layers.PaytableContent.getFlexiText("bet_text");
            const jackpotCurrentText = Layers.PaytableContent.getFlexiText("jackpot_current");
            if (scene == "page_1" || scene == "default" && betText) {
                let betOptions = betModel.generateBetOptions();
                let min = betOptions.coinSizes[0] * betOptions.stakePerLineValues[0] * betOptions.lines;
                let max = betOptions.coinSizes.slice(-1)[0] * betOptions.stakePerLineValues.slice(-1)[0] * betOptions.lines;
                let text = `${Translations.get('min_bet')} <orange>${currency.format(min)}</orange> | ${Translations.get('max_bet')} <orange>${currency.format(max)}</orange>`;
                betText.setText(text);
            }
            if (scene == "page_3" || scene == "default" && jackpotCurrentText) {
                let jackpot = DSComponents.jackpotMeter.getValue(betModel.getTotalBet());
                jackpotCurrentText.setText(`<orange>${currency.format(jackpot)}</orange>`);
            }

        });
        //override flag with disabled skip behaviour
        for (let mask = 0; mask < SmartButtonFlag.MAX; mask++) {
            if ((mask & SmartButtonFlag.REPLAY) > 0) {
                smartButton.overrideBehaviour(mask, DisabledSkipButtonBehaviour);
            }
        }

        Layers.BetBar.onSceneEnter.add((scene: string) => {
            if (scene === "freespins") {
                const value = Layers.BetBar.getText("freespins_x_of_y_value");
                if (value) {
                    value.filters = [new GlowFilter(2, 3, 0, 0x1c4aba)];
                }
            }
        });

        super.complete();

        Layers.MenusContent.onSceneEnter.add(() => {
            const rulesText = Layers.MenusContent.getFlexiText("rules_body");
            const rtp = (SettingsModel as any).rtp_total;
            if (rulesText) {
                if (settingsModel.isJurisdiction([Jurisdiction.UK, Jurisdiction.DE, Jurisdiction.NL]) || autoplayModel.autoplayDisabled) {
                    rulesText.setText(Translations.get("pays_game_rules_jurisdiction", { version: __VERSION__, rtp_total: rtp + "" }));
                } else if (settingsModel.socialSweepstakes && settingsModel.rtpdisplay === false) {
                    rulesText.setText(Translations.get("pays_game_rules_nortp", { version: __VERSION__, rtp_total: rtp + "" }));
                } else {
                    rulesText.setText(Translations.get("rm.bod", { version: __VERSION__, rtp_total: rtp + "" }));
                }
            }
        });

        if (!deviceInfo.isDesktop) {
            Layers.Banners.moveBehind(Layers.MatrixBackground);
            const container = Layers.Custom.get("Torches").container;
            container.parent.setChildIndex(container, container.parent.getChildIndex(Layers.Banners.container));

            const positionTexts = () => {
                if (canvasManager.orientation == Orientation.LANDSCAPE) {
                    const isLeft = settingsModel.getLeftHanded();

                    const arrow1 = Layers.Banners.getSprite("intro_arrow1");
                    const arrow2 = Layers.Banners.getSprite("intro_arrow2");

                    const text2: PIXI.extras.BitmapText = Layers.Banners.getBitmapText("intro_text_2");
                    const text2pt2 = Layers.Banners.getBitmapText("intro_text_2_pt2");
                    const text2pt3 = Layers.Banners.getBitmapText("intro_text_2_pt3");

                    const text6 = Layers.Banners.getBitmapText("intro_text_6");
                    const text6pt2 = Layers.Banners.getBitmapText("intro_text_6_pt2");
                    const text6pt3 = Layers.Banners.getBitmapText("intro_text_6_pt3");

                    if (arrow1 && arrow2 && text2 && text2pt2 && text6 && text6pt2) {

                        let positionArrow1;
                        let positionArrow2;
                        let positionText2;
                        let positionText2pt2;
                        let positionText2pt3;
                        let positionText6;
                        let positionText6pt2;
                        let positionText6pt3;

                        if (isLeft) {
                            positionArrow1 = Layers.Banners.getPosition("arrow1_left");
                            positionArrow2 = Layers.Banners.getPosition("arrow2_left");
                            positionText2 = Layers.Banners.getPosition("intro_text_2_left");
                            positionText2pt2 = Layers.Banners.getPosition("intro_text_2_pt2_left");
                            positionText2pt3 = Layers.Banners.getPosition("intro_text_2_pt3_left");
                            positionText6 = Layers.Banners.getPosition("intro_text_6_left");
                            positionText6pt2 = Layers.Banners.getPosition("intro_text_6_pt2_left");
                            positionText6pt3 = Layers.Banners.getPosition("intro_text_6_pt3_left");
                        } else {
                            positionArrow1 = Layers.Banners.getPosition("arrow1");
                            positionArrow2 = Layers.Banners.getPosition("arrow2");
                            positionText2 = Layers.Banners.getPosition("intro_text_2");
                            positionText2pt2 = Layers.Banners.getPosition("intro_text_2_pt2");
                            positionText2pt3 = Layers.Banners.getPosition("intro_text_2_pt3");
                            positionText6 = Layers.Banners.getPosition("intro_text_6");
                            positionText6pt2 = Layers.Banners.getPosition("intro_text_6_pt2");
                            positionText6pt3 = Layers.Banners.getPosition("intro_text_6_pt3");
                        }
                        arrow1.position.set(positionArrow1.x, positionArrow1.y);
                        arrow2.position.set(positionArrow2.x, positionArrow2.y);
                        text2.position.set(positionText2.x + positionText2.width / 2, positionText2.y);
                        text2pt2.position.set(positionText2pt2.x + positionText2pt2.width / 2, positionText2pt2.y);
                        text2pt3.position.set(positionText2pt3.x + positionText2pt3.width / 2, positionText2pt3.y);
                        text6.position.set(positionText6.x + positionText6.width / 2, positionText6.y);
                        text6pt2.position.set(positionText6pt2.x + positionText6pt2.width / 2, positionText6pt2.y);
                        text6pt3.position.set(positionText6pt3.x + positionText6pt3.width / 2, positionText6pt3.y);
                    }
                }
            }
            const positionBanner = () => {
                if (canvasManager.orientation == Orientation.LANDSCAPE) {
                    const main = Layers.Banners.getSprite("title_main");
                    const leftBanner = Layers.Banners.getSprite("left");
                    const freespins = Layers.Banners.getSprite("title_freespins");

                    const left = Layers.Banners.getPosition("left");
                    const right = Layers.Banners.getPosition("right");

                    const isLeft = settingsModel.getLeftHanded();

                    const position = isLeft ? left : right;

                    if (main && position) {
                        main.position.set(position.x, position.y);
                        // if (isLeft) {
                        //     main.visible = false;
                        //     leftBanner.visible = true;
                        // } else {
                        //     main.visible = true;
                        //     leftBanner.visible = false;
                        // }
                    }
                    if (freespins && position)
                        freespins.position.set(position.x, position.y);
                }
            }

            const positionBoth = () => {
                positionBanner();
                positionTexts();
            }

            Layers.Banners.onSceneEnter.add(positionBoth);

            Components.betMenu.onSettingsOptionsCommitted.add(() => {
                setTimeout(positionBoth, 10);
            });

            canvasManager.onOrientationChange.add(() => {
                setTimeout(positionBoth, 10);
            });
        }
    }

    protected startGame() {
        RevolverSettings.winCount = 0;
        Layers.Custom.get("Coins").onSceneEnter.add((scene: string) => {
            if (scene == "default") {
                Layers.Custom.get("Coins").getParticle("coin").emit = false;
            }
        });
        DSComponents.init();
        super.startGame();
        this.setUpScatterEffects();
        DSComponents.coinPots.init();
        DSComponents.coinPotsTexts.init();
        const setPots = () => {
            setTimeout(() => { // fix because if no timeout stake is the previous value
                const stake = betModel.getTotalBet();
                const record = gameState.getCurrentGame().getCurrentRecord() as ICSpinRecord | ICFreespinRecord;
                if (record && record.persistedPotsValues) {
                    const values = record.persistedPotsValues.get(stake)
                    if (values) {
                        DSComponents.coinPots.setPotLevels(values);
                    } else {
                        DSComponents.coinPots.setPotLevels([0, 0, 0, 0, 0]);
                    }
                } else {
                    DSComponents.coinPots.setPotLevelsFromBet(stake);
                }
                DSComponents.jackpotMeter.setJackpot(stake);
                const jackpotCurrentText = Layers.PaytableContent.getFlexiText('jackpot_current');
                if (jackpotCurrentText) {
                    let jackpot = DSComponents.jackpotMeter.getValue(betModel.getTotalBet());
                    if (jackpot) {
                        jackpotCurrentText.setText(`<orange>${currency.format(jackpot)}</orange>`);
                    }
                }
            }, 1);
        }
        Components.betBar.onBetUpdated.add(setPots);
        Components.betMenu.onBetOptionsCommitted.add(setPots);

    }

    protected showGameIntro() {
        // Layers.Custom.get("Snow").defaultScene().execute();
        // Layers.Custom.get("Snow").show();
        Layers.Custom.get("Coins").onSceneEnter.add((scene: string) => {
            if (scene == "default") {
                Layers.Custom.get("Coins").getParticle("coin").emit = false;
            }
        })
        const emitter_antic_L = Layers.Custom.get("Anticipation").getParticle("emitter_reel_antic_L");
        emitter_antic_L.emit = false;

        const emitter_glow_L = Layers.Custom.get("Anticipation").getParticle("emitter_reel_antic_glow_L");
        emitter_glow_L.emit = false;


        const emitter_antic_R = Layers.Custom.get("Anticipation").getParticle("emitter_reel_antic_R");
        emitter_antic_R.emit = false;

        const emitter_glow_R = Layers.Custom.get("Anticipation").getParticle("emitter_reel_antic_glow_R");
        emitter_glow_R.emit = false;
        return super.showGameIntro();
    }

    private showIntroTexts() {
        Layers.Prompts.onSceneEnter.add((scene: string) => {
            if (scene === "gameintro") {
                if (!deviceInfo.isDesktop) {
                    let splashButton = [
                        Layers.Prompts.container.getChildByName('btn-showon'),
                        Layers.Prompts.container.getChildByName('btn-showoff'),
                        Layers.Prompts.container.getChildByName('toggle_text')
                    ];
                    splashButton.forEach(el => {
                        if (el) {
                            el.alpha = 0;
                        }
                    })
                }
                const textRtp = Translations.get('int.rtp', { rtp: 96.01 });
                var text1 = Layers.Prompts.getText("intro_text_4_3");
                text1.position.y -= 40;
                var text2 = Layers.Prompts.getText("intro_text_4_3_pt2");
                text2.position.y -= 40;
                var text3 = Layers.Prompts.getText("intro_text_4_2");
                text3.position.y -= 40;
                var text4 = Layers.Prompts.getText("intro_text_4_2_pt2");
                text4.position.y -= 40;

                var pixiTextRtp: PIXI.Text;
                pixiTextRtp = Layers.Prompts.getText("[int.rtp]");

                if (pixiTextRtp) {
                    pixiTextRtp.text = textRtp + '%';
                    pixiTextRtp.rotation = - Math.PI / 34;
                    pixiTextRtp.skew.x = - Math.PI / 12;
                }

                var pixiTextVolatility: PIXI.Text;
                const textVolatility = Translations.get('int.vol');
                pixiTextVolatility = Layers.Prompts.getText("[int.vol]");

                if (pixiTextVolatility) {
                    pixiTextVolatility.text = textVolatility;
                    pixiTextVolatility.rotation = - Math.PI / 34;
                    pixiTextVolatility.skew.x = - Math.PI / 12;
                }

                var pixiTextFreeSpins: PIXI.Text;
                pixiTextFreeSpins = Layers.Prompts.getText("[int.fs]");

                if (pixiTextFreeSpins) {
                    pixiTextFreeSpins.style.wordWrap = false;
                }
            }
        });
        Layers.Custom.get("Coins").onSceneEnter.add((scene: string) => {
            if (scene == "default") {
                Layers.Custom.get("Coins").getParticle("coin").emit = false;
            }
        })
    }

    private setupHideBetbarDuringPrompts() {
        Layers.Prompts.onSceneExit.add((scene: string) => {
            if (scene === "freespinssummary" || scene === "freespinswin" || scene === "sessionlimit" || scene === "confirm" || scene === "freespinsretrigger") {
                Layers.BetBar.show();
                this.homeButton = Layers.BetBar.getFlexiButton("home");
                this.homeURL = SettingsModel.homeURL;
                if (this.homeButton) {
                    if (this.homeURL === "close" || this.homeURL === "" || this.homeURL === undefined || this.homeURL === null) {
                        this.homeButton.setVisible(false);
                    } else {
                        this.homeButton.setVisible(true);
                    }
                }
                if (scene != "freespinsretrigger" || deviceInfo.isDesktop)
                    Layers.SmartButton.show();
            }
        });

        Layers.Prompts.onSceneEnter.add((scene: string) => {
            if (scene !== "default" && scene !== "addfreespins" && scene !== "info" && scene !== "error") {
                Layers.BetBar.hide();
                this.homeButton = Layers.BetBar.getFlexiButton("home");
                this.homeURL = SettingsModel.homeURL;
                if (this.homeButton) {
                    if (this.homeURL === "close" || this.homeURL === "" || this.homeURL === undefined || this.homeURL === null) {
                        this.homeButton.setVisible(false);
                    } else {
                        this.homeButton.setVisible(true);
                    }
                }
                Layers.SmartButton.hide();
            }
        });

        Layers.CelebrationForeground.onSceneEnter.add((scene: string) => {
            if (scene == "freespins_bigwin") {
                Layers.SmartButton.hide();
                Layers.BetBar.hide();
            }
        });
        Layers.CelebrationForeground.onSceneExit.add((scene: string) => {
            if (scene == "freespins_bigwin") {
                Layers.SmartButton.show();
                Layers.BetBar.show();
            }
        });
        Layers.Custom.get("Coins").onSceneEnter.add((scene: string) => {
            if (scene == "default") {
                Layers.Custom.get("Coins").getParticle("coin").emit = false;
            }
        })
    }

    private setUpScatterEffects() {
        // todo context?
        Components.matrix.landSignal.add((index: number) => {
            const record = gameState.getCurrentGame().getCurrentRecord() as ICSpinRecord | ICFreespinRecord;
            if (record.isJackpotWon) {
                if (index === 1 || index === 3 || index === 5) {
                    const reel = Components.matrix.getReels()[index - 1];
                    const pot = reel.getSymbols().find(element => element.symbolId === "POT");
                    if (pot) {
                        const transform = pot.getTransform();
                        const layer = pot.getLayer();
                        const front = layer.localToLocal(Layers.MatrixForeground, transform);
                        DSComponents.potLandEmitter.potLandEmit(index, front.x + transform.width / 2, front.y);
                        // if(index === 5) {
                        //     SymbolZoomCommand().execute();
                        // }
                    }
                }
            } else if ((index === 3 || index === 5) && record.anticipations.landSymbols[index - 1] && record.anticipations.landSymbols[index - 1].indexOf("POT") >= 0) {
                soundManager.customEvent("bonus_POT_land_1");
            }
        })
    }
}
